import { user } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { IUserData } from "../../models/common/IUserProfile";

export default new (class UserProfileService {
  public getCurrentUserData = async (
  ): Promise<IApiResponse<IUserData>> => {
    try {
      let endPoint = user.GET_USER_PROFILE_DATA;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IUserData>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IUserData>;
      } else {
        throw error;
      }
    }
  };

  public updateUserProfile = async (
    data: any,
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(user.UPDATE_USER_PROFILE_DATA, [
        `${data}`,
      ]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

})();
